/* tslint:disable */
/* eslint-disable */
/**
 * Webclipping
 * WebclippingのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 過去記事検索レポートのCSV
 * @export
 * @interface ArticlePastSearchCsv
 */
export interface ArticlePastSearchCsv {
    /**
     * 
     * @type {number}
     * @memberof ArticlePastSearchCsv
     */
    reportId: number;
    /**
     * 
     * @type {number}
     * @memberof ArticlePastSearchCsv
     */
    createdStatus: ArticlePastSearchCsvCreatedStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ArticlePastSearchCsv
     */
    file: string | null;
}

/**
* @export
* @enum {string}
*/
export enum ArticlePastSearchCsvCreatedStatusEnum {
    NONE = 0,
    CREATING = 1,
    CREATED = 2
}

export function ArticlePastSearchCsvFromJSON(json: any): ArticlePastSearchCsv {
    return ArticlePastSearchCsvFromJSONTyped(json, false);
}

export function ArticlePastSearchCsvFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArticlePastSearchCsv {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reportId': json['report_id'],
        'createdStatus': json['created_status'],
        'file': json['file'],
    };
}

export function ArticlePastSearchCsvToJSON(value?: ArticlePastSearchCsv | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'report_id': value.reportId,
        'created_status': value.createdStatus,
        'file': value.file,
    };
}

